<div class="col-lg-12 h-100 row align-items-center">



  <span style="color:white;padding:0px;margin:0px;">L</span><span
    style="color:rgb(240, 27, 20);padding:0px;margin:0px;">T</span><span
    style="color:rgb(236, 184, 12);padding:0px;margin:0px;">a</span><span
    style="color:white;padding:0px;margin:0px;">x</span><span style="color:green;padding:0px;margin:0px;">3000</span>
  <span class="menu-title text-white" style="font-size:0.5rem;line-height:0.5rem;"> version 4.0.2</span>

</div>